import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.css";
import "react-toastify/dist/ReactToastify.css";
import { checkAppVersion } from './checkVersion';
import { StytchB2BProvider } from '@stytch/react/b2b';
import { StytchB2BUIClient } from '@stytch/vanilla-js/b2b';

checkAppVersion();


const stytch = new StytchB2BUIClient(process.env.REACT_APP_STYTCH_PUBLIC_TOKEN, {
  cookieOptions: {
    domain: window.location.hostname,
    path: '/',
    availableToSubdomains: false,
  },
});

ReactDOM.render(
  <React.StrictMode>
     <StytchB2BProvider stytch={stytch}>
    <App /> 
    </StytchB2BProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
